// @flow
import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";

import type { DictionaryType } from "../../types/GeneralTypes";

const styles = (theme: DictionaryType): DictionaryType => ({
  para: {
    display: "block",
    marginBlockStart: "1em",
    marginBlockEnd: "1em",
    marginInlineStart: "0px",
    marginInlineEnd: "0px"
  }
});

type MultiLineStringsPropsType = {
  classes: { para: DictionaryType },
  val: string,
  isBrBreak?: boolean
};

class MultiLineStrings extends Component<MultiLineStringsPropsType, *> {
  render(): * {
    return (
      this.props.val &&
      this.props.val.split(this.props.isBrBreak ? "<br>" : "/n").map(
        (item: string, i: number): * => (
          <span className={this.props.classes.para} key={i}>
            {item}
          </span>
        )
      )
    );
  }
}

export default withStyles(styles)(MultiLineStrings);
